import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <a
        href="/"
        data-testid="clinic-badge"
        className="clinic-badge"
        aria-label="State of Art Dental Clinic | Kalpataru Dental Care"
      >
        <span className="dot" />
        State of Art Dental Clinic | Kalpataru Dental Care
      </a>
    </div>
  );
}

export default App;
